<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>CPR nummer</label>
        <app-let-input-cpr formControlName="cpr" />
      </div>
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Dokument Id</label>
        <input pInputText formControlName="dokumentId" />
      </div>
      <div class="control">
        <label>Letsikring Nr</label>
        <input pInputText formControlName="letsikringNr" />
      </div>
      <div class="control">
        <label>Underskrevet digitalt</label>
        <p-checkbox formControlName="underskrevetDigitalt" [binary]="true" />
      </div>
      <div class="control">
        <label>E-Engagement</label>
        <p-checkbox formControlName="eEngagement" [binary]="true" />
      </div>
      <div class="control">
        <label>Dokumentafsendelse</label>
        <p-select
          [options]="afsendelseOptions"
          formControlName="dokumentAfsendelse"
          placeholder="Vælg"
          appendTo="body"
          [showClear]="true" />
      </div>
      <div class="control">
        <label>Dokumenttyper</label>
        <p-multi-select
          [options]="dokumentTyper()"
          formControlName="dokumentTyper"
          placeholder="Vælg typer"
          optionLabel="navn"
          display="chip"
          [maxSelectedLabels]="10"
          appendTo="body"
          scrollHeight="400px"
          optionLabel="text"
          optionValue="value">
          <!-- <ng-template let-doktype #item>
            <div>{{ doktype.navn }} {{ doktype.beskrivelse }}</div>
          </ng-template> -->
        </p-multi-select>
      </div>
      <div class="flex gap-4" style="width: 260px">
        <div class="control">
          <label>Starttidspunkt</label>
          <p-datePicker
            formControlName="startTidspunktDate"
            dateFormat="dd-mm-yy"
            [showIcon]="true"
            appendTo="body" />
        </div>
        <div class="control">
          <label>Sluttidspunkt</label>
          <p-datePicker
            formControlName="slutTidspunktDate"
            dateFormat="dd-mm-yy"
            [showIcon]="true"
            appendTo="body" />
        </div>
      </div>
      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="dokService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
    @if (dokService.datasource.error()) {
      <p-message
        [text]="dokService.datasource.error()"
        severity="error"
        styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
